import { ICache } from '../models/cache';
import { ICacheBuster } from '../models/cache-buster';
import { ICacheClearArgs } from '../models/cache-clear-args';
import { ICacheReadArgs } from '../models/cache-read-args';
import { ICacheWriteArgs } from '../models/cache-write-args';

export class PersistentCache implements ICache {
  constructor(
    private args: {
      memoryCache: ICache;
      dbCache: ICache;
      cacheBuster?: ICacheBuster;
    },
  ) {}

  public async read<T>(args: ICacheReadArgs<T>): Promise<T> {
    return this.args.memoryCache.read({
      ...args,
      retrieve: () => this.args.dbCache.read(args),
    });
  }

  public async write<T>(args: ICacheWriteArgs<T>): Promise<void> {
    await this.args.dbCache.write(args);
    if (this.args.cacheBuster) {
      await this.args.cacheBuster.write(args);
    }
  }

  public async clear(args?: ICacheClearArgs): Promise<void> {
    await this.args.dbCache.clear(args);
    if (this.args.cacheBuster) {
      await this.args.cacheBuster.clear(args);
    }
  }

  public async clearByBucket(bucket: string): Promise<void> {
    await this.args.dbCache.clearByBucket(bucket);
    if (this.args.cacheBuster) {
      await this.args.cacheBuster.clearByBucket(bucket);
    }
  }
}
